import React from 'react';
import { useAuth } from '../hooks/useAuth';
import LoginGate from './LoginGate';

interface RequireAuthProps {
  children: React.ReactNode;
}

/**
 * Route guard (D9) — React idiom, not a literal port of getspeakhub-portal's
 * `guards/auth.guard.ts`. Angular's CanActivate runs before navigation and
 * redirects to a route; a declarative SPA router without a data/loader API
 * (App.tsx uses plain <Routes>, react-router-dom v7's declarative mode) has
 * no equivalent hook point, so this wraps the protected element instead:
 * authenticated -> render children, otherwise -> render the login trigger
 * (LoginGate) in place, which is what "redirect to the login trigger" means
 * here since there is no separate login *route* to redirect to (`/auth/login`
 * is reserved for the mobile bridge and must not be reused or navigated to).
 */
const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <LoginGate returnTo={window.location.pathname} />;
  }

  return <>{children}</>;
};

export default RequireAuth;
